import { render, staticRenderFns } from "./banjiHome.vue?vue&type=template&id=6004a3cc&scoped=true"
import script from "./banjiHome.vue?vue&type=script&lang=js"
export * from "./banjiHome.vue?vue&type=script&lang=js"
import style0 from "./banjiHome.vue?vue&type=style&index=0&id=6004a3cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6004a3cc",
  null
  
)

export default component.exports